import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventsService } from './service/events.service';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { TranslationsEffects } from './effects/events.effects';
import * as EventsStore from './reducers/events.reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(EventsStore.eventsStoreFeature),
    EffectsModule.forFeature([TranslationsEffects]),
  ],
  providers: [EventsService],
})
export class EventsStoreModule {}
